(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mosterd-collection-grid"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mosterd-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SUCCESS_MSG = 'Tak! Du er nu tilmeldt vores nyhedsbrev.';

    function getMsgEl(form) {
      var parent = form.parentElement;
      return parent ? parent.querySelector('[data-md-newsletter-message]') : null;
    }

    function showSuccess(form) {
      var msgEl = getMsgEl(form);
      form.hidden = true;
      if (msgEl) {
        msgEl.textContent = SUCCESS_MSG;
        msgEl.className = 'newsletter-message newsletter-message--success';
        msgEl.hidden = false;
      }
    }

    function bind(form) {
      if (form.dataset.mdNewsletterBound === '1') return;
      form.dataset.mdNewsletterBound = '1';

      var targetName = form.getAttribute('target');
      if (!targetName) return;
      var iframe = document.querySelector('iframe[name="' + targetName + '"]');
      if (!iframe) return;

      var hasSubmitted = false;
      var btn = form.querySelector('button[type="submit"]');
      var originalBtnText = btn ? btn.textContent : '';

      form.addEventListener('submit', function () {
        hasSubmitted = true;
        if (btn) { btn.disabled = true; btn.textContent = 'Tilmelder…'; }
      });

      iframe.addEventListener('load', function () {
        if (!hasSubmitted) return;
        hasSubmitted = false;
        showSuccess(form);
        if (btn) { btn.disabled = false; btn.textContent = originalBtnText; }
      });
    }

    function init() {
      document.querySelectorAll('form[data-md-newsletter-form]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
